import React from "react";
import { bool, string, func } from "prop-types";
import { classes } from "../utils/classes";

const NavbarToggleButton = ({ classNames, isOpen = false, onClick }) => (
	<button
		onClick={onClick}
		type="button"
		className={classes("navbar__toggle", isOpen && "expanded", classNames)}
		data-toggle="toggleButton"
		data-target="#navbar"
	>
		<span className="icon-bar" />
		<span className="icon-bar" />
		<span className="icon-bar" />
	</button>
);

NavbarToggleButton.propTypes = {
	classNames: string,
	onClick: func,
	isOpen: bool,
};

export default NavbarToggleButton;
